// Copyright 30-06-2022 por Fabián Quintanilla Ecomsur Holding S.A ©
// Detalle: Se agrega offline_access al scope para el buen funcionamiento de la sesión

import { Switch, Route } from "react-router-dom";

import { Guard } from "../Guard";

import { GuardedRoute } from "../GuardedRoute";

import { Loading } from "../../pages/Loading";

import { Forbidden } from "../../pages/Forbidden";

import { apps } from "../../apps";

import { Layout } from "../Layout";

import "./App.css";

import { SessionAdmin } from "../SessionAdmin/SessionAdmin";
import { Fragment } from "react";

import { AuthProvider, User, UserManager } from "oidc-react";
import { useHistory } from "react-router-dom";

import { env } from "../../env";

const URL = env.EOS_URL;
const URI = env.EOS_URI;
const CLIENT = env.EOS_CLIENT_ID || '';
const TENANT = env.EOS_TENANT;
const EOS = `${URL}/${URI}`;

export const App = () => {
    const history = useHistory();

    const oidcConfig = {
        onSignIn: (user: User | null) => {
            window.location.hash = "";
            history.replace("/");
        },
        authority: EOS,
        client_id: CLIENT,
        scope: "openid profile email login offline_access",
        redirect_uri: window.location.origin,
        silent_redirect_uri: window.location.origin,
        post_logout_redirect_uri: window.location.origin,
        response_type: "code",
        autoSignIn: true,
        automaticSilentRenew: true,
        loadUserInfo: true,
        ...(TENANT && { extraQueryParams: { tenant: TENANT } }),
        ...(TENANT && { extraTokenParams: { tenant: TENANT } }),
    };

    const userManager = new UserManager({ ...oidcConfig });

    return (
        <Fragment>
            <AuthProvider userManager={userManager}>
                <SessionAdmin />
                <Guard loadingComponent={Loading}>
                    <Layout apps={apps}>
                        <Switch>
                            {apps.map((app) => (
                                <GuardedRoute
                                    key={app.name}
                                    path={app.url}
                                    component={app.component}
                                    forbiddenUrl="/forbidden"
                                />
                            ))}
                            <Route path="/forbidden" component={Forbidden} />
                        </Switch>
                    </Layout>
                </Guard>
            </AuthProvider>
        </Fragment>
    );
};
